import { useAuth0 } from "@auth0/auth0-react";
import { DatePickerField } from "_metronic/_partials/controls";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { InputField, LabelField, MyCheckbox, SelectField, TextareaField } from "components";
import { getDateFormat, getDateFormatForDatePicket, maskDate } from "helper/dateFormat";
import { getCurrency } from "helper/numberFormat";
import { useSearch } from "hook";
import FinanceService from "Lib/API/Finance";
import FinanceSettingService from "Lib/API/FinanceSetting/FinanceSetting";
import { values } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import AddInstallmentsPayment from "../../../../components/Installments/AddInstallmentsPayment";
import InfoTooltip from "../../../../components/InfoTooltip";
import { PriceType } from "../../NewCharge/ChargeType/PercentageFixed";
import UserContext from "../../NewChargeContext";
const Account = ({
  types,
  setShow,
  show,
  formik,
  enableInstallments,
}) => {
  const [search, setSearch] = useState("");
  const [selectedBillingType, setSelectedBillingType] = useState("");
  const [discountType, setDiscountType] = useState("%");
  const [taxType, setTaxType] = useState("%");
  const { searchAction } = useSearch({ action: setSearch });
  const [loading, setLoading] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [accountBillingTypes, setAccountBillingTypes] = useState();
  const [ledgers, setLedgers] = useState();
  const [localFormat, setLocalFormat] = useState(false);

  const dateMask = maskDate();
  const placeholderFormat = getDateFormat();
  const dateFormat = getDateFormatForDatePicket();
  const currency = getCurrency();
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(dateFormat || "mm/dd/yyyy");

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  const billingOptions =
    accountBillingTypes &&
    accountBillingTypes.map((item) => {
      return {
        label: item?.title,
        value: item?._id,
      };
    });

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };

  const formatOptionLabel = ({ label, _id }) => {
    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };

  // Get Account Billing Types List
  const fetchAccountBillingTypes = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getAccountBillingTypes(token)
      .then((res) => {
        setAccountBillingTypes(res?.result);

        // setAccountBillingTypes(res?.result?.map((item) => item.title));
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };
  const exceptThisSymbols = ["e", "E", "+", "-"];

  // Get Ledger Subledger List
  const fetchLedgerSubledgerList = async () => {
    const token = await getAccessTokenSilently();
    await FinanceService.getLedgerSubLedgerList(token)
      .then((res) => {
        setLedgers(res?.ledgers);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };
  const getSubledgerList = ledgers?.find(
    (x) => x._id === formik?.values?.Ledger?.id
  );
  const subLegderOptions = getSubledgerList?.sub_ledgers?.map((item) => {
    return {
      label: item?.sub_ledger_name,
      value: item?._id,
      amount: item?.default_amount,
      notes: item?.notes,
    };
  });
  const legderOptions = ledgers?.map((item) => {
    return {
      label: item?.ledger_name,
      value: item?._id,
      amount: item?.default_amount,
      notes: item?.notes,
    };
  });

  useEffect(() => {
    fetchAccountBillingTypes();
    fetchLedgerSubledgerList();
    if (formik?.values.nextpayment === false) {
      formik.setFieldValue(`batch_name`, "");
      formik.setFieldValue(`description`, "");
      formik.setFieldValue(`Ledger`, {
        name: "",
        id: "",
      });

      formik.setFieldValue(`SubLedger`, {
        name: "",
        id: "",
      });
      formik.setFieldValue(`amount`, "");
      formik.setFieldValue("due_date", "");
      formik.setFieldValue(`discount`, "");
      formik.setFieldValue(`tax`, "");
      formik.setFieldValue(`require_notes`, false);
      formik.setFieldValue(`note`, "");
      formik.setFieldValue(`is_splitted`, false);
      formik.setFieldValue(`split_duration`, "");
      formik.setFieldValue(`split_amount`, "");
      formik.setFieldValue("due_date", "");
    }
  }, []);

  const getLedgerOnChange = async (event) => {
    formik.setFieldValue(`Ledger`, {
      id: event?.value,
      name: event?.label,
    });
    formik.setFieldValue(`SubLedger`, "");
    formik.setFieldValue(`amount`, event?.amount);
    formik.setFieldValue(`require_notes`, event?.notes);
  };
  const getSubLedgerOnChange = async (event) => {
    if (!event) {
      formik.setFieldValue(`SubLedger`, {
        id: "",
        name: "",
      });
      const currentLedger = legderOptions.find(
        (item) => item.value === formik.values?.Ledger?.id
      );
      if (currentLedger) {
        formik.setFieldValue(`amount`, currentLedger.amount);
        formik.setFieldValue(`require_notes`, currentLedger.notes);
      }
      return;
    }
    formik.setFieldValue(`SubLedger`, {
      id: event.value,
      name: event.label,
    });
    formik.setFieldValue(`amount`, event?.amount);
    formik.setFieldValue(`require_notes`, event?.notes);
  };

  useEffect(() => {
    formik.setFieldValue("batch_type", show?.toLowerCase());
  }, [show]);

  useEffect(() => {
    if (formik.values?.discount_type === "%" && formik.values?.discount >= 100) {
      toastr.error("Validation", "discount should be less than 100%")
      formik.setFieldValue("discount", 0)
    }
  }, [formik.values?.discount_type])

  const handleDiscountValue = (e) => {
    if (formik.values?.discount_type === "%") {
      if (e.target.value < 100) {
        formik.setFieldValue(
          `discount`,
          e.target.value.match(regex)[0]
        );
      } else {
        toastr.error("Validation", "Discount should be less than 100 %");
      }
    }
    else {
      formik.setFieldValue(
        `discount`,
        e.target.value.match(regex)[0]
      );
    }
  };

  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
  return (
    <div className="batch-render-comp renderd-comp ">
      <form className="form fv-plugins-bootstrap fv-plugins-framework">
        <div className="col-sm-12 px-sm-18 px-3 pt-10 pb-3 ">
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-8">
              <div className="form-group">
                <InputField
                  mandatory
                  type="text"
                  {...{
                    formik,
                    title: "Bulk Billing",
                    name: `batch_name`,
                    placeholder: "Batch Charge Name",
                    checkValidation: true,
                    value:
                      formik.values?.batch_name ??
                      formik.values?.values[0]?.batch_name,
                  }}
                  style={{
                    backgroundColor: "#F3F6F9",
                  }}
                />
              </div>
            </Col>
            <Col className="col-12 col-md-4 charge-tab">
              <div className="form-group">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <LabelField title="Amount Source" />
                  <InfoTooltip text="Manual = enter amounts yourself. Account = pull amounts from account records. Previous Amount = re-bill past charges matching your filters. File = upload a spreadsheet of amounts." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                </div>
                <div className="charge-type">
                  {types?.map((type, idx) => (
                    <span
                      className={
                        type === "Previous Amount" ? "col-sm-3" : "col-sm-3"
                      }
                      style={
                        type === show
                          ? { background: "#2555ef", color: "white" }
                          : {}
                      }
                      key={idx}
                      onClick={() => {
                        setShow(type);
                        formik.setFieldValue("batch_type", show?.toLowerCase());
                      }}
                      {...{
                        formik,
                        name: `batch_type`,

                        value: formik.values?.batch_type,
                      }}
                    >
                      {type}
                    </span>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-12">
              <div className="form-group">
                <InputField
                  // mandatory
                  type="text"
                  {...{
                    formik,
                    title:
                      "Charge Description (will show on the member statement)",
                    name: `description`,
                    placeholder: "",
                    checkValidation: true,
                    value: formik.values?.description,
                  }}
                  style={{
                    backgroundColor: "#F3F6F9",
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-4  justify-content-start">
            <Col className="col-12 col-md-4 charge-tab">
              <div
                className="form-group"
                style={{
                  zIndex: "1111",
                }}
              >
                <LabelField mandatory title={"Ledger Account"} />
                <Select
                  mandatory={true}
                  {...{
                    formik,
                    name: `Ledger`,
                    checkValidation: false,
                  }}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={legderOptions}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={getLedgerOnChange}
                  value={{
                    label: formik.values?.Ledger?.name,
                    value: formik.values?.Ledger?.id,
                  }}
                  components={{ DropdownIndicator }}
                />
              </div>
            </Col>
            <Col className="col-12 col-md-4 charge-tab">
              <div className="form-group">
                <LabelField title={"Sub-Ledger Account"} />
                <Select
                  mandatory={true}
                  {...{
                    formik,
                    name: `SubLedger`,
                    checkValidation: false,
                  }}
                  isClearable={formik.values?.SubLedger?.id ?? false}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={subLegderOptions}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={getSubLedgerOnChange}
                  value={{
                    label: formik.values?.SubLedger?.name,
                    value: formik.values?.SubLedger?.id,
                  }}
                  components={{ DropdownIndicator }}
                />
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-10  justify-content-start">
            <Col className="col-12 col-md-4">
              <div className="form-group position-relative mb-0">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <LabelField mandatory title={"Account billing type"} />
                  <InfoTooltip text="Only accounts that have one of these billing types assigned will be included in this batch." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                </div>
                <Select
                  {...{
                    formik,
                    name: `billing_type`,
                    checkValidation: false,
                  }}
                  isMulti={true}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={billingOptions}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={(value) => {
                    formik.setFieldValue(`billing_type`, value?.map(item => ({
                      id: item?.value,
                      name: item?.label,
                    })));
                    // formik.setFieldValue(`amount`, value.amount);
                  }}
                  value={formik.values.billing_type.map(item => ({
                    label: item?.name,
                    value: item?.id,
                  }))}
                  components={{ DropdownIndicator }}
                />
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-10  justify-content-start">
            <Col className="col-12 col-md-4">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <LabelField title="Discount" />
                <InfoTooltip text="Reduce the charge amount for this batch, either as a flat amount or a percentage." style={{ marginLeft: '6px', marginBottom: '8px' }} />
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <Col className="col-sm-6 px-0">
                  <InputField
                    type="number"
                    {...{
                      formik,
                      name: `discount`,
                      placeholderIcon: (
                        <span className="amount-placeholder-icon">
                          {formik.values?.discount_type === "%" ? "%" : currency}
                        </span>
                      ),
                      placeholder: "Discount",
                      value: formik.values?.discount,

                      checkValidation: true,
                    }}
                    onKeyDown={(e) => preventArrows(e)}
                    min="0"
                    // onKeyDown={(e) =>
                    //   exceptThisSymbols.includes(e.key) && e.preventDefault()
                    // }
                    handleChange={(e) => {
                      handleDiscountValue(e);
                    }}
                    style={{
                      backgroundColor: "#F3F6F9",
                      border: "none",
                    }}
                  />
                </Col>
                <Col className="col-sm-6 col-md-5  price-type">
                  <PriceType
                    value={formik.values?.discount_type}
                    handleClick={setDiscountType}
                    setFieldValue={formik.setFieldValue}
                    type="discount_type"
                    name="batch_discount"
                  />
                </Col>
              </div>
            </Col>
            <Col className="col-12 col-md-4">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <LabelField title="Tax Deductible" />
                <InfoTooltip text="How much of this charge counts as tax-deductible, either as a flat amount or a percentage. Used for donation receipts." style={{ marginLeft: '6px', marginBottom: '8px' }} />
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <Col className="col-sm-6 px-0">
                  <InputField
                    type="number"
                    {...{
                      formik,
                      name: `tax`,
                      placeholderIcon: (
                        <span className="amount-placeholder-icon">
                          {/* {"$"} */}
                          {formik.values?.tax_type === "%" ? "%" : currency}
                        </span>
                      ),
                      placeholder: "Tax",
                      value: formik.values?.tax,

                      checkValidation: true,
                    }}
                    onKeyDown={(e) => preventArrows(e)}
                    min="0"
                    // onKeyDown={(e) =>
                    //   exceptThisSymbols.includes(e.key) && e.preventDefault()
                    // }
                    handleChange={(e) => {
                      formik.setFieldValue(
                        `tax`,
                        e.target.value.match(regex)[0]
                      );
                    }}
                    style={{
                      backgroundColor: "#F3F6F9",
                      border: "none",
                    }}
                  />
                </Col>
                <Col className="col-sm-6 col-md-5  price-type">
                  <PriceType
                    value={formik.values?.tax_type}
                    handleClick={setTaxType}
                    setFieldValue={formik.setFieldValue}
                    type="tax_type"
                    name="tax_type"
                  />
                </Col>
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-10  justify-content-start">
            <Col className="col-12 col-md-4">
              <div className="form-group showDatePicker mb-0">
                <LabelField title={"Charge Date"} mandatory />
                <DatePicker
                  // isClearable
                  // disabled={true}
                  showIcon
                  placeholderText={placeholderFormat}
                  dateFormat={dateFormat}
                  selected={
                    formik.values?.charge_date &&
                    new Date(formik.values?.charge_date)
                  }
                  onChange={(e) => {
                    formik.setFieldValue(`charge_date`, e);
                  }}
                />
              </div>
            </Col>
            <Col className="col-12 col-md-4 charge-tab">
              <div className="form-group mb-0 date-picker-form">
                <LabelField title={"Due Date"} mandatory />
                <DatePicker
                  isClearable
                  showIcon
                  placeholderText={placeholderFormat}
                  dateFormat={dateFormat}
                  minDate={new Date(formik.values?.charge_date)}
                  selected={
                    formik.values?.due_date && new Date(formik.values?.due_date)
                  }
                  onChange={(e) => {
                    formik.setFieldValue(`due_date`, e);
                  }}
                  customInput={
                    <MaskedInput
                      pipe={autoCorrectedDatePipe}
                      mask={dateMask}
                      keepCharPositions={true}
                      guide={true}
                    />
                  }
                />
              </div>
            </Col>
          </Row>
          <Col className="col mb-10 px-0">
            <div
              className="d-flex align-items-center"
              style={{
                gap: "2rem",
              }}
            >
              <div
                className=""
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <MyCheckbox
                  name={`is_splitted`}
                  split_amount
                  title="Split"
                  handlechange={(event) => {
                    formik.setFieldValue(
                      `is_splitted`,
                      event.target.checked
                    );
                    formik.setFieldValue(`isInstallmentTransaction`, false);
                    formik.setFieldValue(`installmentDetailsTransaction`, undefined);
                  }}
                  value={formik.values?.is_splitted}
                  checked={formik.values?.is_splitted}
                />
                <InfoTooltip text={<>Break this batch <b>charge</b> into multiple payments spread over time, instead of billing the full amount at once.</>} style={{ marginLeft: '6px', marginBottom: '8px' }} />
              </div>
              {enableInstallments && (
                <div
                  className=""
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <MyCheckbox
                    name={`isInstallmentTransaction`}
                    split_amount
                    title="Allow Installments"
                    handlechange={(event) => {
                      formik.setFieldValue(
                        `isInstallmentTransaction`,
                        event.target.checked
                      );
                      formik.setFieldValue(`is_splitted`, false);
                    }}
                    value={formik.values?.isInstallmentTransaction}
                    checked={formik.values?.isInstallmentTransaction}
                  />
                  <InfoTooltip text="Let the payer spread this batch charge across multiple scheduled installments instead of paying it all at once." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                </div>
              )}
            </div>
            {(formik.values?.isInstallmentTransaction && enableInstallments) && (
              <AddInstallmentsPayment
                formik={formik}
                formikKey="installmentDetailsTransaction"
              />
            )}
            {formik.values?.is_splitted && (
              <Row>
                <div className="col-sm-5 col-md-4">
                  <SelectField
                    {...{
                      formik,
                      name: `split_duration`,
                      items: ["day", "week", "month", "quarter", "year"],
                      placeholder: "Select",
                      value: formik.values?.split_duration ? (
                        <span style={{ color: "black" }}>
                          {formik.values?.split_duration}
                        </span>
                      ) : (
                        "Select"
                      ),
                    }}
                    onClick={(data) =>
                      formik.setFieldValue(
                        `split_duration`,
                        data
                      )
                    }
                  />
                </div>
                {formik.values?.split_duration ? (
                  <div className="col-sm-3">
                    <InputField
                      type="number"
                      {...{
                        formik,
                        title: "",
                        name: `number_of_split`,
                        placeholder: "0",
                        value: formik.values?.number_of_split,
                        checkValidation: true,
                      }}
                      onKeyDown={(e) => preventArrows(e)}
                      handleChange={(e) => {
                        const newValue = parseInt(e.target.value);
                        formik.setFieldValue(
                          `number_of_split`,
                          newValue
                        );
                      }}
                    />
                    <div className="placeholder-div">
                      <p>{formik.values?.split_amount}</p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </Row>
            )}
          </Col>
          <Row className="form-row sm-12 mb-0">
            <Col className="col-sm-12 px-0">
              <TextareaField
                mandatory={formik?.values?.require_notes ? true : false}
                {...{
                  formik,
                  title: "Add Note",
                  name: `note`,
                  placeholder: "Note text",
                  style: { resize: "none" },
                  checkValidation: true,
                  onChange: (value) => {
                    formik.setFieldValue(`note`, value);
                  },
                }}
                defaultValue={
                  formik?.values?.note
                }
              />
            </Col>
          </Row>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <MyCheckbox
              {...{
                formik,
                title: "Add Note",
                name: `comment_checkbox`,
              }}
              // disabled={formik.values.type === "edit-charge" ? true : false}
              title="Comment on invoice"
              handleSubmit
              handlechange={(event) => {
                formik.setFieldValue(
                  `comment_checkbox`,
                  event.target.checked
                );
              }}
              checked={formik?.values?.comment_checkbox}
            />
            <InfoTooltip text="Show the note above on the invoice sent to the payer, instead of keeping it internal only." style={{ marginLeft: '6px', marginBottom: '8px' }} />
          </div>
        </div>
      </form>
    </div>
  );
};

export default Account;
